import { DownloadFileByFileStoreId } from "./DownloadFileByFileStoreId";
import { KMCLeftMenuKMCFinancialStatementsList } from "../utils/constants";
import { NavLinkComponent } from "./NavLinkComponent";

export const KMCDepartmentLeftManu = () => {
  return (
    <nav className="sidebar card py-2">
      <ul className="nav flex-column" id="nav_accordion">
        {[
          { label: "KMC Departments", to: "/KMC_Department" },
          { label: "Vision", to: "/AboutUs" },
          { label: "Overview", to: "/Overview" },
          { label: "KMC Functions", to: "/KMCFunctions" },
          { label: "e-Kolkata Centers", to: "/EKolkataCenter" },
          { label: "Basic Statistics", to: "/Basic_Statistic" },
          { label: "Emblem", to: "/Emblem" },
          { label: "KMC Budget", to: "/KMCBudget" },
        ].map((item, index) => (
          <li className="nav-item" key={index}>
            <NavLinkComponent label={item.label} to={item.to} />
          </li>
        ))}
        
        <li className="nav-item-list nav_dropdown">
          <button type="button" className="btn" data-toggle="collapse" data-target="#demo" >
            KMC Financial Statements
            <i className="bi bi-chevron-down" />
          </button>
          <div id="demo" className="collapse">
            {KMCLeftMenuKMCFinancialStatementsList.map((item, index) => (
              <li id="Financial_stmnt" className="nav-item-list nav_dropdown" key={index}>
                <button type="button" className="btn" data-toggle="collapse" data-target={`#demo${index}`} >
                  {item.btnLabel} <i className="bi bi-chevron-down" />
                </button>
                <div id={`demo${index}`} className="collapse">
                  {item.fileList.map((fileDetails, i) => (
                    <li>
                      <DownloadFileByFileStoreId
                        key={i}
                        fileStoreId={fileDetails.fileStoreId}
                        label={fileDetails.label}
                        classAdd={false}
                      />
                    </li>
                  ))}
                </div>
              </li>
            ))}
          </div>
        </li>
        
        <li className="nav-item">
          <DownloadFileByFileStoreId fileStoreId={"18009126-2a59-4f3c-8a94-891f18042026"}
            label={"KMC Structure"} classAdd={false} />
        </li>

      </ul>
    </nav>
  );
};
